import CheckListConstants from "../Constants/CheckListInspectionConstant";
import dispatcher from "../Dispatcher/Dispatcher";
import { EventEmitter } from "events";
let resultList = [];
class CheckListInspectionStores extends EventEmitter {
  emitChange(eventName) {
    this.emit(eventName);
  }

  getResult() {
    return resultList;
  }

  setResult(_value) {
    return (resultList = _value);
  }
  addChangeListener(eventName, callback) {
    this.on(eventName, callback);
  }

  removeChangeListener(eventName, callback) {
    this.removeListener(eventName, callback);
  }

  handleCallback(action) {
    switch (action.type) {
      case CheckListConstants.GET_CHECKLIST_DETAILS_SUCCESS:
        this.setResult(action.result);
        break;
      case CheckListConstants.GET_CHECKLIST_DETAILS_FAILURE:
        this.setResult(action.result);
        break;
      case CheckListConstants.GET_ANLAGE_CHECKLIST_SUCCESS:
        this.setResult(action.result);
        break;
      case CheckListConstants.GET_ANLAGE_CHECKLIST_FAILURE:
        this.setResult(action.result);
        break;
      case CheckListConstants.SAVE_INSPECTION_SUCCESS:
        this.setResult(action.result);
        break;
      case CheckListConstants.SAVE_INSPECTION_FAILURE:
        this.setResult(action.result);
        break;
      default:
    }
    this.emitChange(action.type);
    return true;
  }
}

const checkListInspectionStores = new CheckListInspectionStores();
dispatcher.register(
  checkListInspectionStores.handleCallback.bind(checkListInspectionStores)
);
export default checkListInspectionStores;
